<!-- Shared account template, based on the current dashboard account dialog. -->
<template>
  <div>
    <div v-if="open" class="fixed inset-0 z-40 bg-grey-50 overflow-auto">
      <div class="p-4 bg-white shadow relative z-10">
        <div class="container mx-auto flex justify-between items-center">
          <div class="text-lg text-dark font-bold">
            {{ $t('frontend_sites_account_modal_my_account') }}
          </div>
          <div class="flex">
            <gd-button @click="close" size="auto" class="px-5 h-10"
              >{{ $t('frontend_close') }}
            </gd-button>
          </div>
        </div>
      </div>
      <div
        class="overflow-y-auto custom-scrollbars h-full py-6 px-4"
        style="max-height: calc(100vh - 72px)"
      >
        <div class="container mx-auto">
          <div class="bg-white rounded mt-3 mb-8">
            <!-- <div class="px-4 py-3 border-solid border-grey-200 border-b">
              <h4 class="font-semibold text-grey-700">My Account Settings</h4>
              <div class="text-sm text-grey-700">
                You can configure your account settings here
              </div>
            </div> -->
            <gd-tabs
              :tabs="tabsNew"
              :tabs-with-errors="tabsWithErrors"
              ref="tabsNew"
            >
              <template slot="General Settings">
                <vertical-tabs
                  :tabs="generalSettingsTabs"
                  :wrapper-class="'pt-5 w-3/12 border-r border-grey-200 pb-10'"
                  :content-class="'py-5 px-6'"
                >
                  <template
                    :slot="$t('frontend_sites_account_modal_personal_info')"
                  >
                    <div class="flex">
                      <div class="w-3/4">
                        <div class="p-4">
                          <div
                            class="
                              text-sm text-grey-700
                              font-semibold
                              mt-4
                              mb-2
                            "
                          >
                            {{ $t('frontend_sites_account_modal_name') }}
                          </div>
                          <text-input v-model.trim="$v.name.$model" />
                          <div v-if="$v.name.$error">
                            <div
                              v-if="!$v.name.required"
                              class="
                                error
                                rounded
                                border border-pink-dark
                                mt-2
                                p-2
                              "
                            >
                              {{
                                $t(
                                  'frontend_sites_account_modal_name_is_required'
                                )
                              }}
                            </div>
                            <div
                              v-if="!$v.name.minLength"
                              class="
                                error
                                rounded
                                border border-pink-dark
                                mt-2
                                p-2
                              "
                            >
                              {{
                                $t(
                                  'frontend_sites_account_modal_name_must_have'
                                )
                              }}
                              {{ $v.name.$params.minLength.min }}
                              {{ $t('frontend_sites_account_modal_letters') }}.
                            </div>
                          </div>
                          <div
                            class="
                              text-sm text-grey-700
                              font-semibold
                              mt-4
                              mb-2
                            "
                          >
                            {{ $t('frontend_sites_account_modal_email') }}
                          </div>
                          <text-input v-model.trim="$v.email.$model" disabled />
                          <div class="text-sm text-grey-500 mt-2">
                            {{ $t('frontend_account_settings_chnage_email_address_contact_support') }}
                          </div>
                          <div v-if="$v.email.$error">
                            <div
                              v-if="!$v.email.required"
                              class="
                                error
                                rounded
                                border border-pink-dark
                                mt-2
                                p-2
                              "
                            >
                              {{
                                $t(
                                  'frontend_sites_account_modal_email_is_required'
                                )
                              }}
                            </div>
                            <div
                              v-if="!$v.email.minLength"
                              class="
                                error
                                rounded
                                border border-pink-dark
                                mt-2
                                p-2
                              "
                            >
                              {{
                                $t(
                                  'frontend_sites_account_modal_email_must_have'
                                )
                              }}
                              {{ $v.email.$params.minLength.min }}
                              {{ $t('frontend_sites_account_modal_letters') }}.
                            </div>
                            <div
                              v-if="!$v.email.email"
                              class="
                                error
                                rounded
                                border border-pink-dark
                                mt-2
                                p-2
                              "
                            >
                              {{
                                $t(
                                  'frontend_sites_account_modal_write_valid_email'
                                )
                              }}
                            </div>
                          </div>
                          <div
                            class="
                              text-sm text-grey-700
                              font-semibold
                              mt-4
                              mb-2
                            "
                          >
                            {{ $t('frontend_sites_account_modal_language') }}
                          </div>
                          <div class="cursor-pointer">
                            <Dropdown
                              :options="langs"
                              @change="onChange($event)"
                              class="w-full text-grey-700 h-10 large-dropdown"
                              v-model="locale"
                            />
                          </div>
                          <div
                            class="
                              flex
                              items-center
                              mt-4
                              text-sm
                              bg-grey-50
                              rounded-lg
                              p-2
                              text-grey-600
                              font-semibold
                            "
                          >
                            <InfoIcon class="mr-1" />
                            {{
                              $t(
                                'frontend_sites_account_modal_changes_to_your_account'
                              )
                            }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="w-1/4 flex flex-col justify-center items-center"
                      >
                        <div
                          class="relative rounded-full overflow-hidden lg:block"
                        >
                          <img
                            v-if="profilePicture"
                            class="relative rounded-full w-40 h-40 object-cover"
                            :src="profilePicture"
                            alt=""
                          />
                          <img
                            v-else
                            class="relative rounded-full w-40 h-40 object-cover"
                            src="../assets/user.png"
                            alt=""
                          />
                          <label
                            for="user-photo"
                            class="
                              absolute
                              inset-0
                              w-full
                              h-full
                              bg-black bg-opacity-75
                              flex
                              items-center
                              justify-center
                              text-sm
                              font-medium
                              text-white
                              opacity-0
                              hover:opacity-100
                              focus-within:opacity-100
                              cursor-pointer
                            "
                            @click="openProfilePictureModal"
                          >
                            <span>{{ $t('frontend_change') }}</span>
                            <span class="sr-only">
                              {{ $t('frontend_user_photo') }}</span
                            >
                          </label>
                        </div>
                      </div>
                    </div>
                  </template>

                  <template
                    :slot="$t('frontend_sites_account_modal_change_password')"
                  >
                    <div class="p-4">
                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_new_password') }}
                      </div>
                      <text-input
                        @keyup="checkPasswordLength"
                        v-model="password"
                      />
                      <div v-if="passwordFormatError">
                        <div
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t(
                              'frontend_sites_account_modal_password_must_have_at_least_8_letters'
                            )
                          }}
                        </div>
                      </div>
                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{
                          $t('frontend_sites_account_modal_repeat_new_password')
                        }}
                      </div>
                      <text-input
                        @keyup="checkPasswordMatch"
                        v-model="passwordConfirm"
                      />
                      <div v-if="passwordMatchError">
                        <div
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t(
                              'frontend_sites_account_modal_password_doesnot_match'
                            )
                          }}
                        </div>
                      </div>
                      <div
                        class="
                          flex
                          items-center
                          mt-4
                          text-sm
                          bg-grey-50
                          rounded-lg
                          p-2
                          text-grey-600
                          font-semibold
                        "
                      >
                        <InfoIcon class="mr-1" />
                        {{
                          $t(
                            'frontend_sites_account_modal_website_changes_to_your_account'
                          )
                        }}
                      </div>
                    </div>
                  </template>
                  <template
                    :slot="$t('frontend_sites_account_modal_contact_details')"
                  >
                    <div class="p-4">
                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_phone_number') }}
                      </div>
                      <text-input
                        v-model.trim="$v.contactDetails.phone.$model"
                      />
                      <div v-if="$v.contactDetails.phone.$error">
                        <div
                          v-if="!$v.contactDetails.phone.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t(
                              'frontend_sites_account_modal_phone_number_must_have'
                            )
                          }}
                          {{ $v.contactDetails.phone.$params.minLength.min }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_address') }}
                      </div>
                      <text-input
                        v-model.trim="$v.contactDetails.address.$model"
                      />
                      <div v-if="$v.contactDetails.address.$error">
                        <div
                          v-if="!$v.contactDetails.address.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t('frontend_sites_account_modal_address_must_have')
                          }}
                          {{ $v.contactDetails.address.$params.minLength.min }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_city') }}
                      </div>
                      <text-input
                        v-model.trim="$v.contactDetails.city.$model"
                      />
                      <div v-if="$v.contactDetails.city.$error">
                        <div
                          v-if="!$v.contactDetails.city.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t('frontend_sites_account_modal_city_must_have')
                          }}
                          {{ $v.contactDetails.city.$params.minLength.min }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_postal_code') }}
                      </div>
                      <text-input
                        v-model.trim="$v.contactDetails.postal_code.$model"
                      />
                      <div v-if="$v.contactDetails.postal_code.$error">
                        <div
                          v-if="!$v.contactDetails.postal_code.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t(
                              'frontend_sites_account_modal_postal_code_must_have'
                            )
                          }}
                          {{
                            $v.contactDetails.postal_code.$params.minLength.min
                          }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_country') }}
                      </div>
                      <text-input
                        v-model.trim="$v.contactDetails.country.$model"
                      />
                      <div v-if="$v.contactDetails.country.$error">
                        <div
                          v-if="!$v.contactDetails.country.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t('frontend_sites_account_modal_country_must_have')
                          }}
                          {{ $v.contactDetails.country.$params.minLength.min }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_state') }}
                      </div>
                      <text-input
                        v-model.trim="$v.contactDetails.state.$model"
                      />
                      <div v-if="$v.contactDetails.state.$error">
                        <div
                          v-if="!$v.contactDetails.state.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t('frontend_sites_account_modal_state_must_have')
                          }}
                          {{ $v.contactDetails.state.$params.minLength.min }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>
                    </div>
                  </template>

                  <template
                    :slot="$t('frontend_sites_account_modal_socail_media')"
                  >
                    <div class="p-4">
                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_facebook') }}
                      </div>
                      <text-input
                        v-model.trim="$v.socialMedia.facebook.$model"
                      />
                      <div v-if="$v.socialMedia.facebook.$error">
                        <div
                          v-if="!$v.socialMedia.facebook.url"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t(
                              'frontend_sites_account_modal_facebook_valid_url'
                            )
                          }}
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_twitter') }}
                      </div>
                      <text-input
                        v-model.trim="$v.socialMedia.twitter.$model"
                      />
                      <div v-if="$v.socialMedia.twitter.$error">
                        <div
                          v-if="!$v.socialMedia.twitter.url"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t('frontend_sites_account_modal_twitter_valid_url')
                          }}
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_instagram') }}
                      </div>
                      <text-input
                        v-model.trim="$v.socialMedia.instagram.$model"
                      />
                      <div v-if="$v.socialMedia.instagram.$error">
                        <div
                          v-if="!$v.socialMedia.instagram.url"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{ $t('frontend_sites_enter_valid_url') }}
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_linkedin') }}
                      </div>
                      <text-input
                        v-model.trim="$v.socialMedia.linkedin.$model"
                      />
                      <div v-if="$v.socialMedia.linkedin.$error">
                        <div
                          v-if="!$v.socialMedia.linkedin.url"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{ $t('frontend_sites_enter_valid_url') }}
                        </div>
                      </div>
                    </div>
                  </template>

                  <template
                    :slot="$t('frontend_sites_account_modal_business_details')"
                  >
                    <div class="p-4">
                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_company') }}
                      </div>
                      <text-input
                        v-model.trim="$v.businessInfo.company_name.$model"
                      />
                      <div v-if="$v.businessInfo.company_name.$error">
                        <div
                          v-if="!$v.businessInfo.company_name.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t('frontend_sites_account_modal_company_must_have')
                          }}
                          {{
                            $v.businessInfo.company_name.$params.minLength.min
                          }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sales_tax_id') }}
                      </div>
                      <text-input
                        v-model.trim="$v.businessInfo.tax_id.$model"
                      />
                      <div v-if="$v.businessInfo.tax_id.$error">
                        <div
                          v-if="!$v.businessInfo.tax_id.required"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t(
                              'frontend_sites_account_modal_sales_tax_id_requires'
                            )
                          }}
                        </div>
                        <div
                          v-if="!$v.businessInfo.tax_id.minLength"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{
                            $t('frontend_sites_account_modal_tax_id_must_have')
                          }}
                          {{ $v.businessInfo.tax_id.$params.minLength.min }}
                          {{ $t('frontend_sites_account_modal_letters') }}.
                        </div>
                      </div>

                      <div
                        class="text-sm text-grey-700 font-semibold mt-4 mb-2"
                      >
                        {{ $t('frontend_sites_account_modal_website') }}
                      </div>
                      <text-input
                        v-model.trim="$v.businessInfo.website.$model"
                      />
                      <div v-if="$v.businessInfo.website.$error">
                        <div
                          v-if="!$v.businessInfo.website.url"
                          class="error rounded border border-pink-dark mt-2 p-2"
                        >
                          {{ $t('frontend_sites_enter_valid_url') }}
                        </div>
                      </div>
                    </div>
                  </template>
                </vertical-tabs>
                <div class="gs-account-modal__save-footer">
                  <p v-if="accountSaveError" role="alert" class="gs-account-modal__save-error">{{ accountSaveError }}</p>
                  <span v-if="isLoading" role="status">Saving settings…</span>
                  <button type="button" @click="update" :disabled="isLoading" class="gs-button gs-button--primary px-10 h-10">
                    {{ $t('frontend_save') }}
                  </button>
                </div>
              </template>
              <template slot="Domains">
                <div class="py-4">
                  <account-domains />
                </div>
              </template>
              <template slot="Plans">
                <div class="px-4 py-8">
                  <billing-plans />
                </div>
              </template>
              <template slot="Billing Settings">
                <div>
                  <div><account-billing /></div>
                </div>
              </template>
              <template slot="Developer">
                <div class="p-4">
                  <div class="text-sm text-grey-700 font-semibold mt-4 mb-2">
                    {{ $t('frontend_sites_account_modal_api_key') }}
                  </div>
                  <text-input
                    :selectAll="true"
                    :disabled="true"
                    v-model="apiKey"
                  />
                </div>
              </template>

              <template slot="Affiliate Settings">
                <AffiliateSettings />
              </template>
               <template slot="Integrations">
                <MyIntegrations />
              </template>
              <template slot="App Settings">
                <vertical-tabs
                  :tabs="appSettingtabs"
                  ref="appSettingtabs"
                  :wrapper-class="'pt-5 w-56 border-r border-grey-200 pb-10'"
                >
                  <template slot="GrooveSell Settings">
                    <vertical-tabs
                      :tabs="groovesellSettingtabs"
                      ref="groovesellSettingtabs"
                      :wrapper-class="'pt-5 w-56 border-r border-grey-200 pb-10'"
                    >
                      <template slot="Vendor Settings">
                        <VendorSettings />
                      </template>
                      <template slot="Payment Gateways">
                        <PaymentGateway />
                      </template>
                    </vertical-tabs>
                  </template>
                  <template slot="GrooveMail Settings">
                    <SenderSettings />
                  </template>
                  <template slot="GrooveVideo Settings">
                    <VideoSettings />
                  </template>
                </vertical-tabs>
              </template>
            </gd-tabs>
            <gd-modal
              ref="profileImageModal"
              name="profileImageModal"
              width="100%"
              height="100%"
            >
              <image-picker-without-modal
                :value="profilePicture"
                modal="true"
                remove="false"
                @close-modal="$refs.profileImageModal.close()"
                @selected="selectedProfilePicture"
              ></image-picker-without-modal>
            </gd-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default { name: 'GrooveAccountTemplate' };
</script>
